export const APP_CONFIG = {
  GOOGLE_RECAPTCHA_SITE_KEY: "6LcpCrcqAAAAANvU5gStILUAAiWFJV7Evli0751c",
  GOOGLE_RECAPTCHA_SECRET_KEY: "6LcpCrcqAAAAAGUZzL-pxuQENV_lpgWuozG1orIi",
}
